import { useBlockProps, BlockControls, useInnerBlocksProps } from '@wordpress/block-editor';
import { ToolbarGroup,ToolbarButton } from "@wordpress/components";
import { __ } from '@wordpress/i18n';
import { useState } from "@wordpress/element";
import {useSelect} from "@wordpress/data";
import { ImageThumbnail } from "../../../components/imageThumbnail";
import './editor.scss';
export default function Edit(props){
    const blockProps = useBlockProps();
    const [editMode,setEditMode] = useState(true);
   
    const innerBlockProps = useInnerBlocksProps({
        className: 'fse-gallery-items',
    },{
        allowedBlocks: ["fse-blocks/fse-gimg"]
    })

     const innerBlocks = useSelect((select) => {
         const {getBlocksByClientId} = select('core/block-editor');
         const block = getBlocksByClientId(props.clientId)[0];
         return block?.innerBlocks
     },['props.clientId']);

 const [prevModeImage,setPrevModeImage] = useState({
        imageId: innerBlocks[0]?.attributes?.imageId,
        blockId: innerBlocks[0]?.clientId
    });
    return (
        <>
        <div {...blockProps}>
           {!!editMode && <div className="fse-gallery-edit">
            <span className="fse-gallery-edit-label">
                {__('Fse Image Gallery','fse-blocks')}
            </span>
            <div {...innerBlockProps}  />

            </div>}
           {!editMode && <div className="fse-gallery-preview">{(innerBlocks || []).map(innerBlock =>(
            <ImageThumbnail 
            key={innerBlock.clientId}
            imageId={innerBlock.attributes.imageId} 
            height="75px"
            className={`fse-gallery-thumb ${innerBlock.clientId === prevModeImage.blockId ? 'fseg-selected' : ''}`} 
            onClick={()=>{
                setPrevModeImage({
                    imageId: innerBlock.attributes.imageId,
                    blockId: innerBlock.clientId
                })
            }}
            />
           ))}</div>}
           
        </div>
       {!editMode &&  <div>
            <ImageThumbnail 
            height="initial" 
            imageId={prevModeImage?.imageId}  />
        </div>}
        <BlockControls>
                <ToolbarGroup>
                    <ToolbarButton
                        icon={editMode?"edit":"welcome-view-site"}
                        label={editMode? __('Edit','fse-blocks'):__('Preview','fse-blocks')}
                        onClick={()=>{
                            setEditMode((prevState)=>!prevState);
                        }}
                    />
                </ToolbarGroup>

            </BlockControls>
        </>
    );
}